import { IDisplayOptions } from '@modeso/types__aumico-lib-annualreport-be';

export const START_AT_PAGE_DEFAULT_VALUE = '1';

export const DEFAULT_GERMAN_DISPLAY_OPTIONS: IDisplayOptions = {
    showCompanyInfos: true,
    showAccounts: false,
    hidePreviousYear: false,
    showAccountProofForBalance: false,
    showAccountProofForIncome: false,
    showCoverSheet: true,
    showCompanyLogo: false,
    showUIDonCover: true,
    showTableOfContents: true,
    showNotesInDetailInToc: false,
    disableBalanceSheetPageBreak: false,
    hideDecimalPlaces: false,
    hideEmptyLines: true,
    showFliTotal: false,
    showGroupHeaders: true,
    showGroupTotals: true,
    showFcp: true,
    showAop: true,
    showCfs: true,
    showNotes: true,
    showComplementaryReports: true,
    showEms: false,
    showFas: true,
    printInGrayscale: false,
    showCustomPageNumbers: false,
    startAtPage: START_AT_PAGE_DEFAULT_VALUE,
    mainTitle: null,
    subtitle: null,
    dateTitle: null,
    // REV-20899: reclasses are now always included in totals.
    showReClassInSums: true,
    showAdjustmentInSums: false,
    showRatios: true,
    showShareholderInformation: false,
    incomeItemNameForCalculatingRatio: null,
    showAccountNumbers: false,
    aopHideDecimalPlacesValues: false,
    aopHideDecimalPlacesRatios: false,
    aopHideEmptyLines: false,
    notesHideDecimalPlacesValues: false,
    notesHideDecimalPlacesRatios: false,
    notesHideEmptyLines: false,
    finStatementHideDecimalPlacesValues: false,
    finStatementHideDecimalPlacesRatios: false,
    finStatementHideEmptyLines: false,
    finStatementRoundToThousands: false,
    notesRoundToThousands: false,
    aopRoundToThousands: false,
    nonBreakingHyphen: false,
    showReportCompanyLogo: false,
    applyGroupingMasking: true,
    internalLabel: null,
    repeatAppendixTitle: false,
};
